import { makeStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles<Theme>(() => ({
  sidebarSpacer: {
    paddingLeft: "12rem",
  },
  container: {
    padding: "2.5rem",
  },
}));

export default useStyles;
